module.exports = __webpack_public_path__ + "img/image11.0ee849da.jpg";